import { themePage, themePageImage } from "#templates/views/article_themepage_template";
import { createGuid } from "#scripts/general_functions.js";
import { setResponsiveImage, getImageByContentId } from "#scripts/images";
import { getColorFromBGColor } from "#scripts/tools/textcolor.js";

export const articleThemepage = (article) => {
	const contentHtml = document.getElementById("contentHtml");
	const maincontent = document.getElementById("maincontent");
	const warningscontainer = document.getElementById("warnings_container");

	contentHtml.classList.remove("container");
	contentHtml.classList.remove("article");
	maincontent.classList.add("temaside");
	// add bg color to bradcrumb div
	// #maincontent .container .row
	const orgHtml = document.querySelector("#maincontent .container").outerHTML;
	const color = getColorFromBGColor(article.metaDynamic?.Temafarge || "#FFFFFF");
	const breadcrumbColors = `background-color:${article.metaDynamic.Temafarge};color:${color};--fullnav__bc__item_link_color:${color}`;
	const newHtml = `<div class='tema__breadcrumb__container' style='${breadcrumbColors}'>${orgHtml}</div>`;
	document.querySelector("#maincontent .container").outerHTML = newHtml;

	const meta = article.metaObject || false;
	const metaData = JSON.parse(decodeURIComponent(meta));
	const imgId = createGuid();
	const hasImage = !!metaData.imageContentId;
	const mainImage = themePageImage({ id: imgId });

	getImageByContentId(metaData.imageContentId, (img) => {
		if (img.url !== undefined && img.url.length > 0) {
			const elm = document.getElementById(`${imgId}`);
			if (elm) {
				elm.setAttribute("data-src", img.url);
				elm.setAttribute("src", "/images/transparent.png");
				elm.setAttribute("data-imagehotspot", `${img.imageHotspotX},${img.imageHotspotY}`);
				setResponsiveImage(elm);
			}
		}
	});

	return themePage({
		pageType: article.pageTypeId,
		title: article.title,
		intro: article.intro,
		temaFarge: article.metaDynamic?.Temafarge,
		hasImage,
		mainImage,
		bodyTextJustify: window.serverdata.configMeta.aim.style?.view?.theme__content__text_justify || "center",
		content: article.content,
	});
};
